import React from "react";
import { FAQ_ITEMS } from "../../../lib/landingContent";
import "./qa.css";

const QASection: React.FC = () => {
  return (
    <section className="qa-section">
      <div className="qa-inner">
        <p className="qa-kicker">FAQ</p>
        <h2 className="qa-title">Common Questions</h2>

        <div className="qa-list">
          {FAQ_ITEMS.map((item) => (
            <details className="qa-item" key={item.id}>
              <summary>
                <span className="qa-question">{item.question}</span>
                <span className="qa-summary-icon" aria-hidden="true" />
              </summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QASection;
